import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { Users, Building2, Phone, Info } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
import { PHONE, PHONE_TEL } from '../constants/business';
export function BanquetsFundraisers() {
  useDocumentMeta('Banquets & Fundraisers | Kjergaard Sports', 'Kjergaard Sports works with local organizations and large groups on fundraising firearm purchases and compliant winner transfer logistics.');
  return <div data-id="element-233">
      <PageHero title="Banquets & Fundraisers" image="https://cdn.magicpatterns.com/uploads/1BGu7nrTdE3WRCeMKF6WrW/store-tour-wide.jpg" alt="Kjergaard Sports store interior — banquet and fundraiser firearm partner" data-id="element-234" />

      <section className="py-20 bg-brand-offwhite" data-id="element-235">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-236">
          <div className="max-w-3xl mb-16" data-id="element-237">
            <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-238">
              A Trusted Partner for Fundraising Firearms
            </h2>
            <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-239">
              Kjergaard Sports works with many local organizations and national
              groups to source firearms for banquets, fundraisers, and special
              events. We help organizations plan the firearm portion of their
              event in a way that is practical, organized, and compliant with
              applicable requirements.
            </p>
          </div>

          <div className="max-w-3xl mb-16" data-id="element-240">
            <h3 className="text-2xl md:text-3xl font-serif text-brand-charcoal mb-4" data-id="element-241">
              Fundraising Firearms
            </h3>
            <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-242">
              We can help you source the right mix of firearms for your event —
              from popular hunting rifles and shotguns to specialty pieces that
              drive bidder interest.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-243">
            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-244">
              <Users className="w-10 h-10 text-brand-hunter mb-5" data-id="element-245" />
              <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-246">
                Small Local Events
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-247">
                One-time fundraisers, sportsman's clubs, school events, and
                small community groups.
              </p>
            </div>
            <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream" data-id="element-248">
              <Building2 className="w-10 h-10 text-brand-hunter mb-5" data-id="element-249" />
              <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-250">
                Large National Organizations
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-251">
                Multi-event partners, annual banquets, and regional or national
                groups planning across many events.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-bone" data-id="element-252">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-253">
          <div className="grid lg:grid-cols-2 gap-16 items-start" data-id="element-254">
            <div data-id="element-255">
              <h3 className="text-2xl md:text-3xl font-serif text-brand-charcoal mb-4" data-id="element-256">
                Transfer Logistics for Winners
              </h3>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-257">
                After the event, we manage the firearm transfers to winners. We
                coordinate the paperwork, dealer-to-dealer shipments when
                needed, and compliance steps so your organization doesn't have
                to.
              </p>
            </div>
            <div data-id="element-258">
              <h3 className="text-2xl md:text-3xl font-serif text-brand-charcoal mb-4" data-id="element-259">
                Planning for Better ROI
              </h3>
              <p className="text-lg text-brand-charcoal/80 leading-relaxed" data-id="element-260">
                We help organizations build firearm strategies that improve
                return on investment — choosing the right items at the right
                price points, sizing inventory to your audience, and planning
                for what tends to sell vs. what tends to draw interest.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-brand-cream" data-id="element-261">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-262">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6 text-center" data-id="element-263">
            Regulatory Considerations
          </h2>
          <p className="text-lg text-brand-charcoal/80 leading-relaxed text-center" data-id="element-264">
            Firearm fundraising involves regulatory and logistical
            considerations that are different from regular retail. We'll talk
            through what applies to your event so you can plan accordingly.
          </p>
        </div>
      </section>

      <section className="py-20 bg-brand-offwhite" data-id="element-265">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-266">
          <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-267">
            Start with a Conversation
          </h2>
          <p className="text-lg text-brand-charcoal/80 mb-10 leading-relaxed" data-id="element-268">
            Every event is different. Call us so we can talk about your
            organization, your goals, and how we can help.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-269">
            <a href={PHONE_TEL} className="bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-7 py-3.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center" data-id="element-270">
              <Phone className="w-5 h-5 mr-2" data-id="element-271" />
              Call the Store
            </a>
            <Link to="/contact" className="border-2 border-brand-hunter text-brand-hunter hover:bg-brand-hunter hover:text-brand-offwhite px-7 py-3.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center" data-id="element-272">
              Ask About a Fundraiser
            </Link>
            <Link to="/contact" className="border border-brand-charcoal/20 hover:border-brand-leather text-brand-charcoal px-7 py-3.5 rounded-sm font-medium transition-colors inline-flex items-center justify-center" data-id="element-273">
              Contact Kjergaard Sports
            </Link>
          </div>

          <div className="bg-brand-cream border-l-4 border-brand-leather p-6 text-left max-w-2xl mx-auto" data-id="element-274">
            <div className="flex items-start" data-id="element-275">
              <Info className="w-5 h-5 text-brand-leather mr-3 flex-shrink-0 mt-0.5" data-id="element-276" />
              <p className="text-brand-charcoal/85 text-sm leading-relaxed" data-id="element-277">
                Kjergaard Sports does not run online raffles, online contests,
                or online purchase flows. All firearm-related fundraising
                activities, transfers, and winner deliveries are handled in
                accordance with applicable federal, state, and local laws. This
                page is general information only and is not legal advice.
              </p>
            </div>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-278" />
    </div>;
}